import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'utilities/hooks';
import { useEffect } from 'react';
import { smx3AccessTokenSetter } from '../../utilities/smx3AccessTokenSetter';
import { removeLastOpenedUrl } from '../../utilities/userLocalStorage';

const LegacyAccessPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        (async () => {
            const isSet = await smx3AccessTokenSetter(searchParams);
            const redirectTo = searchParams.get('redirectTo') ?? '/';
            if (isSet) {
                removeLastOpenedUrl();
                navigate(redirectTo);
            } else {
                localStorage.removeItem('accessToken');
                navigate('/signin');
            }
        })();
    }, []);

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    minHeight: '100vh',
                }}
            >
                <CircularProgress />
                <Typography variant="body1">Signing you in…</Typography>
            </Box>
        </>
    );
};

export default LegacyAccessPage;
